import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import Header from '../components/Header'
import Login from '../containers/Login'
import NoMatch from '../containers/NoMatch'
import Profile from '../containers/Profile'
import UserAccount from '../containers/UserAccount'
import Contact from '../containers/Contact'
import Resources from '../containers/Resources'
import NewsUpdates from '../containers/NewsUpdates'
import ApplicantDashboard from '../containers/ApplicantDashboard'
import LocationApplicationDashboard from '../containers/LocationApplicationDashboard'
import Can from '../config/Can'

class Routes extends Component {
  state = {
    height: 500,
    width: 1600
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this))
  }

  updateDimensions = () => {
    let width = 1600
    let height = 500

    if (typeof window !== 'undefined') {
      let headerHeight = 0
      if (document.getElementById('header') !== null)
        headerHeight = document.getElementById('header')!.clientHeight

      height = window.innerHeight - headerHeight + 20
      width = window.innerWidth
    }

    this.setState({ height, width })
  }

  render() {
    const { width, height } = this.state
    return (
      <div>
        <Router>
          <Header />
          <Switch>
            <Route
              exact
              path="/"
              render={props => <NewsUpdates {...props} height={height} width={width} />}
            />
            <Route
              exact
              path="/applicant/:applicationType?/:applicationTab?"
              render={props => <ApplicantDashboard {...props} height={height} width={width} />}
            />
            <Route
              exact
              path="/provider/locationApplication/:applicationTab?/:applicationId?"
              render={props => <LocationApplicationDashboard {...props} height={height} width={width} />}
            />
            {/* <Route
              exact
              path="/provider/locationApplication/:applicationTab?/:applicationId?"
              render={props => 
                (
                <>
                  <Can I='View' a='ProviderPortal'>
                    {() => <LocationApplicationDashboard {...props} height={height} width={width} />}
                  </Can>
                  <Can I='View' not a='ProviderPortal'>
                    {() => <Redirect to='/' />}
                  </Can>
                </>
              )}
            /> */}
            <Route
              exact
              path="/profile"
              render={props => (
                <>
                  <Can I='View' a='ProviderPortal'>
                    {() => <Profile {...props} height={height} width={width} />}
                  </Can>
                  <Can I='View' not a='ProviderPortal'>
                    {() => <Redirect to='/' />}
                  </Can>
                </>
              )}
            />
            <Route
              exact
              path="/contact"
              render={props => (
                <>
                  <Can I='View' a='ProviderPortal'>
                    {() => <Contact {...props} height={height} width={width} />}
                  </Can>
                  <Can I='View' not a='ProviderPortal'>
                    {() => <Redirect to='/' />}
                  </Can>
                </>
              )}
            />
            <Route
              exact
              path="/resources"
              render={props => (
                <>
                  <Can I='View' a='ProviderPortal'>
                    {() => <Resources {...props} height={height} width={width} />}
                  </Can>
                  <Can I='View' not a='ProviderPortal'>
                    {() => <Redirect to='/' />}
                  </Can>
                </>
              )}
            />
            <Route
              exact
              path="/newsupdates"
              render={props => (
                <>
                  <Can I='View' a='ProviderPortal'>
                    {() => <NewsUpdates {...props} height={height} width={width} />}
                  </Can>
                  <Can I='View' not a='ProviderPortal'>
                    {() => <Redirect to='/' />}
                  </Can>
                </>
              )}
            />
            <Route
              exact
              path="/user/:page?"
              render={props => (
                <>
                  <Can I='View' a='ProviderPortal'>
                    {() => <UserAccount {...props} height={height} width={width} />}
                  </Can>
                  <Can I='View' not a='ProviderPortal'>
                    {() => <Redirect to='/' />}
                  </Can>
                </>
              )}
            />
            <Route
              exact
              path="/login/:page?"
              render={(props: any) => (
                <Login {...props} height={height} width={width} />
              )}
            />
            <Route
              render={props => <NoMatch {...props} height={height} width={width} />}
            />
          </Switch>
        </Router>
      </div>
    )
  }
}

export default Routes